import $ from 'jquery';

const $filterHeading = $('.js-posts-heading');
const $filterCategory = $('.js-posts-category');
const $filterAuthor = $('.js-posts-author');
const $filterReset = $('.js-posts-reset');
const $posts = $('.js-post');

const defaultHeading = $filterHeading.text();

function filterByCategory(index, element) {
  const $element = $(element);
  const category = $element.attr('data-category');
  const categoryValue = $filterCategory.val();
  if (categoryValue === '' || categoryValue === null) {
    return true;
  }
  console.log({ category, categoryValue });
  return category === categoryValue;
}

function filterByAuthor(index, element) {
  const $element = $(element);
  const author = $element.attr('data-author');
  const authorValue = $filterAuthor.val();
  if (authorValue === '' || authorValue === null) {
    return true;
  }
  return author === authorValue;
}

function updateHeading() {
  const category = $filterCategory.val();
  const author = $filterAuthor.val();
  if (category && author) {
    $filterHeading.text(`${category} Articles by ${author}`);
  } else if (category) {
    $filterHeading.text(`${category} Articles`);
  } else if (author) {
    $filterHeading.text(`Articles by ${author}`);
  } else {
    $filterHeading.text(defaultHeading);
  }
}

function handleChange() {
  updateHeading();
  $filterAuthor.prop('disabled', $filterCategory.val());
  $filterCategory.prop('disabled', $filterAuthor.val());
  $posts.hide().filter(filterByCategory).filter(filterByAuthor).show();
  $filterReset.show();
}

function handleReset() {
  $posts.show();
  $filterCategory.val('');
  $filterCategory.prop('disabled', false);
  $filterAuthor.val('');
  $filterAuthor.prop('disabled', false);
  $filterReset.hide();
  updateHeading();
}

$filterCategory.on('change', handleChange);
$filterAuthor.on('change', handleChange);
$filterReset.on('click', handleReset);
